import {ItemType} from 'antd/es/menu/interface';

import {resolveChainForPathname, RouteMatchRowType} from '../helpers/route-path-resolution';

export function getIsUserAvailable(isWgisSupportUser: boolean): boolean {
    return !isWgisSupportUser;
}

function getMenuItemFlatKeys(
    menuItems: Array<ItemType>,
    parentKeys?: Array<React.Key>
): Array<[React.Key, Array<React.Key>]> {
    return menuItems.flatMap((item) => {
        if (!item || !item.key) {
            return [];
        }

        const itemKeysPath = [...(parentKeys ?? []), item.key];

        return [
            [item.key, itemKeysPath],
            ...(item.type === 'submenu' && item.children ? getMenuItemFlatKeys(item.children, itemKeysPath) : []),
        ];
    });
}

function menuKeyToRoutePattern(key: React.Key): string | null {
    if (typeof key === 'string') {
        return key;
    }

    if (typeof key === 'number') {
        return String(key);
    }

    return null;
}

function menuMatchRowsFromFlat(flat: Array<[React.Key, Array<React.Key>]>): Array<RouteMatchRowType<React.Key>> {
    return flat
        .map(([key, keyPath]) => {
            const pattern = menuKeyToRoutePattern(key);

            if (!pattern) {
                return null;
            }

            return {pattern, chain: keyPath};
        })
        .filter((row): row is RouteMatchRowType<React.Key> => row !== null);
}

/**
 * Resolves Ant Design Menu `selectedKeys` (full key path) for the current URL.
 * Supports React Router path patterns in menu keys (e.g. `/company-matching/:providerId/...`).
 */
export function getSelectedKeysForPathname(pathname: string, menuItems: Array<ItemType>): Array<string> {
    const flat = getMenuItemFlatKeys(menuItems);
    const rows = menuMatchRowsFromFlat(flat);
    const chain = resolveChainForPathname(pathname, rows);

    return chain.map(String);
}
